/*
 *ngFor="let c of oneDimArray | sortBy:'asc'"
 *ngFor="let c of arrayOfObjects | sortBy:'asc':'propertyName'"
*/
import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';

@Pipe({ name: 'sortBy', standalone: true })
export class SortPipe implements PipeTransform {
  transform(value: any[], order = '', column: string = '', lower: string): any[] {
    // column='Department';
    if (!value || order === '' || !order) { return value; } // no array
    if (value.length <= 1) { return value; } // array with only one item
    if (!column || column === '') {
      if(order==='asc'){return value.sort()}
      else{return value.sort().reverse();}
    } // sort 1d array

    if(lower=="lower"){
      return orderBy(value, [user => user[column]?.toLowerCase() || ''], [order]);
    }else{
      return orderBy(value, [column], [order]);
    }
  }
}